export default __webpack_public_path__ + "static/media/back.70599b8b.PNG";